export default __webpack_public_path__ + "static/media/shoes1-afterA-2048w.ab165543.png";